up.compiler('[row-collapse]', (element) => {
  // CAUTION: hidden field is not a real checkbox
  const checkboxClass = element.getAttribute('checkbox-selector')

  const collapse = function (evt) {
    const checkbox = !!checkboxClass ? document.querySelector(checkboxClass) : undefined
    if (!!checkboxClass && !checkbox) {
      console.error('form_collapsed checkbox not found!')
    }

    if (evt.target.closest('.collapse-toggle')) {
      const targetClass = element.getAttribute('toggle-target')
      const targetElements = document.querySelectorAll(targetClass)
      const showWhenCollapsedSelector = element.getAttribute('show-when-collapsed-target')
      const showWhenCollapsedElements = showWhenCollapsedSelector ? document.querySelectorAll(showWhenCollapsedSelector) : []

      if (element.classList.contains('collapsed')) {
        if (checkbox) {
          checkbox.value = "false"
        }
        targetElements.forEach((target) => {
          target.closest('tr').classList.remove('hidden')
        })
        showWhenCollapsedElements.forEach((el) => el.classList.add('hidden'))
        element.classList.remove('collapsed')
      } else {
        if (checkbox) {
          checkbox.value = "true"
        }
        targetElements.forEach((target) => {
          target.closest('tr').classList.add('hidden')
        })
        showWhenCollapsedElements.forEach((el) => el.classList.remove('hidden'))
        element.classList.add('collapsed')
      }

    }
  }

  up.on(element, 'click', collapse)
  // Allow toggling the collapsed state via keyboard, delegate to click.
  up.on(element, 'keydown', '[role="button"]', (event, caret) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      event.stopPropagation()
      element.click()
      // next microtask, after UI updated
      setTimeout( () => {
        if (element.classList.contains('collapsed')) {
          element.querySelector('.collapse-toggle--closed').focus()
        } else {
          element.querySelector('.collapse-toggle--open').focus()
        }
      }, 0)
    }
  })
})
